export default "__VITE_ASSET__CnKEQwnF__"